import { cn } from "@/shared/lib/utils";
import type { FeatureFlagValue, FeatureFlagValueType } from "./types";
import { formatValueBlock } from "./format-value";

interface FeatureFlagValueDisplayProps {
  readonly value: FeatureFlagValue;
  readonly valueType: FeatureFlagValueType;
  readonly className?: string;
  readonly testId?: string;
}

export function FeatureFlagValueDisplay({
  value,
  valueType,
  className,
  testId,
}: FeatureFlagValueDisplayProps) {
  const text = formatValueBlock(value, valueType);
  return (
    <pre
      data-testid={testId}
      className={cn(
        "max-h-64 overflow-auto rounded-md border border-border bg-muted/30 p-3 font-mono text-xs text-foreground",
        "whitespace-pre-wrap break-words",
        className,
      )}
    >
      {text}
    </pre>
  );
}
